import { useAtom } from "jotai";

import { useArtworkForm, usePlacementPosition } from "@design-lab/entities/artwork";
import { panFrontAtom, panBackAtom, zoomFrontAtom, zoomBackAtom } from "../model/state";

export function usePlacementZoomAndPan() {
  const { lens } = useArtworkForm();
  const currentPlacementLens = lens.focus("currentPlacement");
  const currentPlacement = usePlacementPosition(currentPlacementLens);

  const isFrontPlacement =
    currentPlacement.placement === "front" || currentPlacement.placement === "frontLeftChest";

  const [zoomFront, setZoomFront] = useAtom(zoomFrontAtom);
  const [zoomBack, setZoomBack] = useAtom(zoomBackAtom);
  const zoom = isFrontPlacement ? zoomFront : zoomBack;
  const setZoom = isFrontPlacement ? setZoomFront : setZoomBack;

  const [frontPan, setFrontPan] = useAtom(panFrontAtom);
  const [backPan, setBackPan] = useAtom(panBackAtom);
  const pan = isFrontPlacement ? frontPan : backPan;
  const setPan = isFrontPlacement ? setFrontPan : setBackPan;

  return {
    zoom,
    pan,
    setZoom,
    setPan
  };
}
